/**
 * RoleGate: shows its children only when the user's organisation role allows `cap` (backend
 * services/role_policy.py); otherwise a short note, or nothing with `quiet`. Used for whole pages
 * (campaign wizard, branding) and for blocks of actions.
 */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Lock } from 'lucide-react';
import { useCan } from '../contexts/AuthContext';

export function RoleNote({ cap, className = '' }) {
  const { t } = useTranslation('common');
  return (
    <div className={`panel role-note ${className}`} role="note" data-testid={`role-note-${cap}`}>
      <Lock size={16} aria-hidden="true" />
      <span>{t(`role_note_${cap}`, { defaultValue: t(`role_denied_${cap}`) })}</span>
    </div>
  );
}

export default function RoleGate({ cap, quiet = false, children }) {
  return useCan(cap) ? children : quiet ? null : <RoleNote cap={cap} />;
}
